export default "__VITE_ASSET__DKvXX$pf__"